export enum WebsocketConnectionState {
  Connecting = 0,
  Open = 1,
  Closing = 2,
  Closed = 3,
  Reconnecting = 4,
}
